<h5 class="section-title">Datos Personales</h5>
<div class="columns is-multiline">
  @if (socio().associatedClientName) {
    <app-constitution-readonly-field label="Cliente" [value]="socio().associatedClientName" colSize="6" />
  }
  <app-constitution-readonly-field label="Nombre" [value]="socio().nombre" colSize="6" />
  <app-constitution-readonly-field label="NIF" [value]="socio().nif" colSize="6" />
  <app-constitution-readonly-field label="Domicilio" [value]="socio().domicilio" colSize="6" />
</div>

@if ((socio().representatives?.length ?? 0) > 0) {
  <table class="styled-table" style="margin-top: 0.5rem;" aria-label="Representantes del socio">
    <thead>
      <tr>
        <th scope="col">Representante</th>
        <th scope="col">NIF</th>
      </tr>
    </thead>
    <tbody>
      @for (rep of socio().representatives; track rep.name + rep.nif) {
        <tr>
          <td>{{ rep.name }}</td>
          <td>{{ rep.nif || '—' }}</td>
        </tr>
      }
    </tbody>
  </table>
}

@if ((socio().shareNumberings?.length ?? 0) > 0) {
  <h5 class="section-title">Acciones Totales</h5>
  <table class="styled-table grouped-shares-table" aria-label="Acciones totales del socio">
    <thead>
      <tr>
        <th scope="col">Serie</th>
        <th scope="col" class="numeric-cell">Nº Acciones</th>
        <th scope="col" class="numeric-cell">Numeración</th>
        <th scope="col" class="numeric-cell">Número total</th>
        <th scope="col">Título</th>
        <th scope="col" class="numeric-cell">% Titularidad</th>
        <th scope="col" class="numeric-cell">Nº Acc. Ajustada</th>
        <th scope="col" class="numeric-cell">VN (€)</th>
      </tr>
    </thead>
    <tbody>
      @for (group of groupedShares(); track group.groupId) {
        @for (row of group.rows; track $index; let isFirst = $first) {
          <tr>
            @if (isFirst) {
              <td [attr.rowspan]="group.rows.length + 1">{{ group.seriesName }}</td>
              <td class="numeric-cell" [attr.rowspan]="group.rows.length + 1">
                {{ formatShareAmount(group.partnerSharesInSeries) }}
              </td>
            }
            <td class="numeric-cell">
              {{ formatShareAmount(row.sharesNumberFrom) }} - {{ formatShareAmount(row.sharesNumberTo) }}
            </td>
            <td class="numeric-cell">{{ formatShareAmount(row.sharesCount) }}</td>
            <td>{{ tituloLabel(row.titulo) }}</td>
            <td class="numeric-cell">{{ formatPct4(row.ownershipPercentage) }}</td>
            <td class="numeric-cell">{{ formatAdjusted(row.adjustedShares) }}</td>
            <td class="numeric-cell">{{ row.vnEur != null ? formatEuro(row.vnEur) : '' }}</td>
          </tr>
        }
        <tr class="grouped-shares-subtotal-row">
          <td colspan="4" class="subtotal-label"></td>
          <td class="numeric-cell"><strong>{{ formatAdjusted(group.subtotalAdjusted) }}</strong></td>
          <td class="numeric-cell"><strong>{{ formatEuro(group.subtotalVn) }}</strong></td>
        </tr>
      }
    </tbody>
  </table>

  <div class="totals-and-validation-container socios-participation-totals" style="margin-top: 0.75rem;">
    @for (t of seriesTotals(); track t.seriesName) {
      <div class="validation-box success">
        <div class="validation-label">TOTAL {{ t.seriesName }}</div>
        <div class="validation-value">
          <strong>{{ t.fractionLabel }}</strong>
          <span class="percent-value"> = {{ t.percentLabel }}</span>
        </div>
      </div>
    }
    <div class="validation-box secondary modal-total-acciones-ajustadas" style="flex-direction: column; align-items: flex-start;">
      <div class="validation-label">TOTAL ACCIONES AJUSTADAS</div>
      <div class="validation-value" style="align-self: flex-end;">
        <strong>{{ formatAdjusted(modalTotalAccionesAjustadas()) }}</strong>
      </div>
    </div>
  </div>
}

<h5 class="section-title">Socio Trabajador</h5>
<div class="columns is-multiline">
  <app-constitution-readonly-field
    label="Socio Trabajador"
    [value]="formatYesNo(socio().esSocioTrabajador)"
    colSize="12"
  />
</div>

@if (socio().esSocioTrabajador) {
  <div class="columns is-multiline">
    <app-constitution-readonly-field
      label="Régimen de la Seguridad Social"
      [value]="socio().regimenSeguridadSocial"
      colSize="6"
    />
    <app-constitution-readonly-field
      label="Encuadramiento"
      [value]="socio().encuadramiento"
      colSize="6"
    />
    <app-constitution-readonly-field
      label="Autónomos a Cargo de"
      [value]="socio().autonomosACargoDe"
      colSize="6"
    />
    @if (socio().autonomosACargoNombre) {
      <app-constitution-readonly-field
        [label]="socio().autonomosACargoDe === 'Empresa' ? 'Empresa' : 'Persona'"
        [value]="socio().autonomosACargoNombre"
        colSize="6"
      />
    }
    <app-constitution-readonly-field label="IBAN" [value]="socio().iban" colSize="6" />
    <app-constitution-readonly-field
      label="Rendimiento Neto Mensual"
      [value]="monthlyIncomeLabel()"
      colSize="6"
    />
    <app-constitution-readonly-field
      label="Mutua ACC: Trabajo/EP"
      [value]="socio().mutuaAcc"
      colSize="6"
    />
    <app-constitution-readonly-field
      label="Mutua CC / IT"
      [value]="socio().mutuaCcIt"
      colSize="6"
    />
  </div>
}

<h5 class="section-title">Junta General</h5>
<div class="columns is-multiline">
  <app-constitution-readonly-field
    label="Presidente Junta General"
    [value]="formatYesNo(socio().esPresidente)"
    colSize="12"
  />
  <app-constitution-readonly-field
    label="Secretario Junta General"
    [value]="formatYesNo(socio().esSecretario)"
    colSize="12"
  />
  <app-constitution-readonly-field
    label="Observaciones"
    [value]="socio().observaciones"
    colSize="12"
    [multiline]="true"
  />
</div>
